import { Outlet } from 'react-router-dom';
import Header from './Header';

function MainLayout() {
  return (
    <div className="app">
      <Header />
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}

export default MainLayout;
